import { configureStore } from '@reduxjs/toolkit'
import { authReducer, utilsReducer, chatReducer } from "../Features";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        utils: utilsReducer,
        chat: chatReducer
    },
})
